<template>
  <div class="home">
    <van-nav-bar
      left-arrow
      title="通知公告"
      @click-left="$router.back()"
    ></van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="listItem" v-for="item in Announcement" :key="item.id">
          <div class="itemLeft">
            <i class="iconItem"></i>
            <i v-if="show" class="iconItem1"></i>
          </div>
          <div class="itemCenter">
            <div class="centerLeft">
              <div>{{ item.title }}</div>
              <p>发布时间：{{ item.createTime }}</p>
            </div>
            <div class="centerRight">
              <van-icon name="arrow" size="15" @click="toDetail(item)" />
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { AnnouncementList } from "@/api/home.js";
export default {
  name: "Announcement",
  data() {
    return {
      show: false,
      count: 0,
      pageSize: 7,
      loading: false,
      finished: false,
      refreshing: false,
      Announcement: [],
    };
  },
  methods: {
    async onLoad() {
      this.count++;
      const data = await AnnouncementList(this.count, this.pageSize);
      if (data.data.data.records.length !== 0) {
        this.Announcement.push(...data.data.data.records);
        this.loading = false;
      } else {
        this.finished = true;
      }
    },
    toDetail(item) {
      this.$router.push({
        path: "/AnnouncementDetails",
        query: {
          content: item.content,
          createTime: item.createTime,
          title: item.title,
        },
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast("刷新成功");
        this.refreshing = false;
        this.onLoad();
      }, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.listItem {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 10px;
  display: flex;
  .itemLeft {
    flex: 15%;
    padding-top: 15px;
    // padding-left: 10px;
  }
  .itemCenter {
    flex: 85%;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .centerLeft {
      text-align: left;
      // padding-left: 12px;
      flex: 4;
      div {
        font-size: 16px;
        font-weight: 700;
      }
      p {
        color: #a0a0a0;
      }
    }
    .centerRight {
      flex: 1;
      .van-icon {
        padding-top: 18px;
      }
    }
    div {
      padding-top: 5px;
    }
    p {
      padding: 5px 0;
      font-size: 12px;
    }
  }
}
.home {
  height: auto;
}
.iconItem {
  display: block;
  width: 35px;
  height: 35px;

  margin-left: 10px;
}
.iconItem1 {
  display: block;
  width: 35px;
  height: 35px;
}
</style>
